module.exports = __webpack_public_path__ + "GY.png?1313a7ca64289caaecaeab58147be2b4";